import { Component, OnInit, OnDestroy, ViewEncapsulation, signal } from '@angular/core';
import { GridColumnData } from 'src/app/features/grid/classes/grid-column-data.class';
import { GridSettings } from 'src/app/features/grid/classes/grid-settings.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastService } from '../../services/toast.service';
import { LosTokenService } from 'src/app/services/los-token.service';
import { LOSToken } from 'src/app/models/los-token';


@Component({
  selector: 'app-los-token-view',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './los-token-view.component.html',
  styleUrls: ['./los-token-view.component.scss'],
  providers: [LosTokenService],
  standalone: false,
})
export class LosTokenViewComponent implements OnInit, OnDestroy {
  componentDestroyed$ = new Subject<boolean>();

  gettingData = false;
  hasData = false;

  allGroup: LOSToken[] = [];

  public gridSettings = signal<GridSettings>(null);
  public gridLoading = signal<boolean>(true);
  settingsReady = false;
  public expandDetailsBy = (dataItem: any): any => {
    return dataItem.losTokenId;
  };

  constructor(
    private toastService: ToastService,
    private lTService: LosTokenService,
  ) {
  }

  ngOnInit(): void {
    this.setupGrid();
    this.getAllData();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  getAllData(): void {
    this.allGroup = [];

    this.lTService.getLOSTokens()
    .pipe(takeUntil(this.componentDestroyed$))
    .subscribe(
      (data) => {
        if (data != null && data.length > 0) {
          // process formatting
          data.forEach(x => {
            this.allGroup.push(new LOSToken(x));
          });
          this.gridLoading.set(false);
          this.updateGrid();
        }
        else {
          this.gridLoading.set(false);
          this.updateGrid();
        }
      },
    );
  }

  reloadActiveToken() {
    this.toastService.toastCreate('Reloading LOS Tokens.', 'Info');
    this.getAllData();
  }

  //--------------------------- Grid Functions ------------------------------------------//
  setupGrid(): void {
    this.gridSettings.set(new GridSettings({
      data: [],
      loading: this.gridLoading,
      columns: [
        new GridColumnData({ field: 'dataSourceTypeId', header: 'DataSourceType', width: '130px', minWidth: '50px'}),
        new GridColumnData({ field: 'losServerName', header: 'LOSServerName', width: '50px', minWidth: '50px'}),
        new GridColumnData({ field: 'losUserName', header: 'LOSUserName', width: '150px', minWidth: '50px'}),
        new GridColumnData({ field: 'tokenCreatedDate', header: 'Token Created Date', type:'date', format: 'MM/dd/yyyy h:mm a', width: '150px', minWidth: '50px'}),
      ],
      sortMode: 'single',
      dataKey: 'losTokenId',
      rowExpansion: {
        enabled: true,
        allowMultiple: true,
      },
      selection: {
        enabled: true,
        mode: 'single',
        selectionType: 'row',
      },
    }));
    this.settingsReady = true;
  }

  updateGrid() {
    this.gridSettings.set(new GridSettings({
      ...this.gridSettings(),
      data: this.allGroup,
      loading: this.gridLoading,
    }));
  }
}
